var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "videoLi",
    class: _vm.returnVideoClass
  }, [_vm.showMoveIcon ? _c('div', {
    staticClass: "checkBox"
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.moveParty
    },
    model: {
      value: _vm.selectPip,
      callback: function ($$v) {
        _vm.selectPip = $$v;
      },
      expression: "selectPip"
    }
  })], 1) : _vm._e(), _c('NewAttendUser', {
    ref: "attendUser",
    attrs: {
      "devicePlatform": _vm.devicePlatform,
      "degreeHost": _vm.degreeHost,
      "singChannel": _vm.singChannel,
      "title": _vm.title,
      "nickName": _vm.nickName,
      "avatar": _vm.avatar,
      "pipVolume": _vm.pipVolume,
      "tagName": _vm.tagName,
      "anywherePopShow": _vm.anywherePopShow,
      "theme": _vm.theme,
      "muteVideo": _vm.muteVideo,
      "muteAudio": _vm.muteAudio,
      "needStartVoip": _vm.needStartVoip,
      "userInfo": _vm.userInfo,
      "selectRid": _vm.selectRid,
      "buttonStatus": _vm.liveInfo.peerId,
      "isAudioLevel": _vm.isAudioLevel,
      "operateList": _vm.btnList,
      "devicesInfo": _vm.devicesInfo,
      "outputRtilCode": _vm.outputRtilCode,
      "liveInfo": _vm.liveInfo,
      "controlMute": _vm.controlMuteVideo,
      "rtc": _vm.rtc,
      "sourceType": _vm.sourceType,
      "leftRightRtilCode": _vm.leftRightRtilCode,
      "remoteNetWorks": _vm.remoteNetWorks,
      "hearSelf": _vm.hearSelf
    },
    on: {
      "callback": _vm.attendCallback
    },
    scopedSlots: _vm._u([_vm.talkbackStatus ? {
      key: "iconSlot",
      fn: function () {
        return [_c('LazyAudio', {
          attrs: {
            "userInfo": _vm.userInfo,
            "liveInfo": _vm.liveInfo,
            "rtilCode": _vm.singChannel.id,
            "talkBackInfo": _vm.talkBackInfo,
            "isHost": _vm.userInfo.rtilCode == _vm.singChannel.id
          },
          on: {
            "callback": _vm.lazyAudioCallback
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }, [_vm._t("default")], 2), _vm.State.showFootBar ? _c('div', {
    staticClass: "drop-down"
  }, [_c('div', {
    staticClass: "drop"
  }, [_c('LiveSourceSelect', {
    ref: `liveSource${_vm.singChannel.rtilCode}`,
    attrs: {
      "allRList": _vm.receiverList,
      "partyCode": _vm.userInfo.joinCode,
      "nickName": _vm.nickName,
      "rtilCode": _vm.singChannel.id,
      "memberId": _vm.singChannel.tid,
      "talkBack": _vm.talkBackInfo[_vm.singChannel.id],
      "liveInfo": _vm.liveInfo,
      "needAudio": _vm.singChannel.shareCode == _vm.singChannel.id ? false : true
    },
    on: {
      "callback": _vm.callbackByLiveSource
    }
  })], 1)]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };